import { DOCUMENT_SIDES, QUESTION_TYPES } from './constants';

function isFileQuestion(model) {
  return model.type === QUESTION_TYPES.FILE;
}

function isRequired(model) {
  return !!model.required;
}

function getDocumentSides(model) {
  return DOCUMENT_SIDES[model.name] ?? DOCUMENT_SIDES.DEFAULT;
}

function getUpload(model) {
  return model.prescreener?.upload;
}

function sideHasFile(upload, questionName, clientType, side) {
  const fileMetadata = upload.getFile({ questionName, clientType, side });
  return !!fileMetadata?.file;
}

function allSidesHaveFiles(upload, sides, questionName, clientType) {
  return sides.every(side => sideHasFile(upload, questionName, clientType, side));
}

export function validateFileUpload(value, model) {
  if (!isFileQuestion(model) || !isRequired(model)) return true;

  const sides = getDocumentSides(model);
  const upload = getUpload(model);
  if (!upload) return true;

  const { name: questionName, clientType } = model;
  if (!allSidesHaveFiles(upload, sides, questionName, clientType)) {
    return model.validationMessageKeys?.required;
  }

  return true;
}
